/**
 * Hybrid PeekIn component.
 * Routes between the Tailwind implementation (preferred) and the styled-system
 * implementation (for consumers using system props).
 */

import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import { PeekInStyled } from "./PeekInStyled";
import { PeekInTailwind } from "./PeekInTailwind";
import type { TypePeekInProps } from "./PeekInTypes";

export const PeekInHybrid = (props: TypePeekInProps) => {
  // PeekIn exposes only domain props (open, actions, panelToggle, snap-point
  // config, children), none of which are styled-system props, so
  // hasStyledProps is effectively always false; the styled-system branch is
  // retained as a pattern-conformance fallback.
  if (hasStyledProps(props)) {
    return <PeekInStyled {...props} />;
  }
  return <PeekInTailwind {...props} />;
};

PeekInHybrid.displayName = "PeekIn";
